import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { AppImage, resolveImageSrc } from "@/shared/ui/AppImage";
import { ExternalLinkIcon, ZoomInIcon } from "lucide-react";
import { useState } from "react";

type Props = {
  documentRef: string | null | undefined;
};

export function KycDocumentPreview({ documentRef }: Props) {
  const [open, setOpen] = useState(false);
  const key = documentRef?.trim() ?? "";
  const src = key ? resolveImageSrc(key) : null;

  if (!src) {
    return (
      <p className="text-muted-foreground rounded-2xl border border-dashed border-border/60 bg-muted/15 px-4 py-6 text-center text-xs leading-relaxed">
        ຍັງບໍ່ມີເອກະສານທີ່ລູກຄ້າສົ່ງມາ
      </p>
    );
  }

  return (
    <>
      <div className="space-y-3 rounded-2xl border border-border/60 bg-muted/20 p-3">
        <button
          type="button"
          className="bg-background block w-full overflow-hidden rounded-xl border border-border/60 transition-opacity hover:opacity-90"
          onClick={() => setOpen(true)}
        >
          <AppImage
            src={key}
            alt="KYC document"
            fit="contain"
            className="aspect-[4/3] max-h-64 w-full bg-muted/30"
          />
        </button>

        <div className="flex flex-wrap gap-2">
          <Button
            type="button"
            size="sm"
            variant="secondary"
            className="rounded-xl"
            onClick={() => setOpen(true)}
          >
            <ZoomInIcon className="mr-1.5 size-4" />
            ເບິ່ງເອກະສານ
          </Button>
          <Button
            type="button"
            size="sm"
            variant="outline"
            className="rounded-xl"
            asChild
          >
            <a href={src} target="_blank" rel="noopener noreferrer">
              <ExternalLinkIcon className="mr-1.5 size-4" />
              ເປີດແທັບໃໝ່
            </a>
          </Button>
        </div>

        <p className="truncate font-mono text-[0.65rem] text-muted-foreground">
          {key}
        </p>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl gap-4">
          <DialogHeader>
            <DialogTitle>ເອກະສານ KYC</DialogTitle>
          </DialogHeader>
          <AppImage
            src={key}
            alt="KYC document full"
            fit="contain"
            className="max-h-[75vh] w-full rounded-xl bg-muted/30"
          />
          <div className="flex justify-end">
            <Button type="button" size="sm" variant="outline" asChild>
              <a href={src} target="_blank" rel="noopener noreferrer">
                <ExternalLinkIcon className="mr-1.5 size-4" />
                ເປີດແທັບໃໝ່
              </a>
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
